export default "__VITE_ASSET__DPBU9xw3__"